import { render, staticRenderFns } from "./UiTransitionOpacity.vue?vue&type=template&id=b860f652&"
import script from "./UiTransitionOpacity.vue?vue&type=script&lang=js&"
export * from "./UiTransitionOpacity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports